import { styled } from "../../../styled-components";
import Img from "../../../ui/smart/img/img";
import { maximumLeftWidthLarge, maximumLeftWidthSmall } from "../../smart/tablet-container/tablet-container-style";

export const FlyoutMenuWrapper = styled.div<{ expandLeftPanel: boolean }>`
    position: absolute;
    width: min(82%, ${p => (p.expandLeftPanel ? maximumLeftWidthLarge : maximumLeftWidthSmall)}px);
    height: 100%;
    left: 0;
    top: 0;

    ${p =>
        p.theme.flyout.rightBorderColor !== "transparent" &&
        `border-right: 1px solid ${p.theme.flyout.rightBorderColor};`}

    display: flex;
    flex-direction: column;

    background-color: ${p => p.theme.flyout.bgColor};

    /* this is a terrible hack to work around a chrome rendering bug.
        to remove verify that on mobile chrome opening and closing the flyout
        doesn't result in any rendering issues.
     */
    opacity: 0.9999;

    will-change: transform;

    transition: transform 0.25s cubic-bezier(0.12, 0.97, 0.19, 1);

    padding-bottom: var(--safe-area-inset-bottom);

    #flyout-tablet & {
        width: 350px;
    }
`;

export const FlyoutContainer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;

    background: transparent;
    pointer-events: none;

    transition: background-color 0.25s;

    & ${FlyoutMenuWrapper} {
        transform: translateX(-102%);
    }

    &.open {
        background: ${p => p.theme.flyout.overlayColor};
        pointer-events: auto;

        ${FlyoutMenuWrapper} {
            transform: translateX(0);
        }
    }

    & > * {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }

    color: ${p => p.theme.fgColorDark};

    #flyout-tablet & {
        pointer-events: auto;
        background: transparent;
    }
    #flyout-tablet & ${FlyoutMenuWrapper} {
        transform: translateX(0);
    }
`;

export const Scroller = styled.div`
    overflow-y: auto;

    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    flex-direction: column;

    pointer-events: auto;

    // Safari, Chrome, and derivatives of both
    ::-webkit-scrollbar {
        display: none;
    }

    // Firefox
    scrollbar-width: none;
`;

export const Header = styled.div`
    border-bottom: 1px solid ${p => p.theme.flyout.headerBorderColor};

    padding: calc(30px + var(--safe-area-inset-top)) 24px 20px 24px;

    background-color: ${p => p.theme.flyout.headerBg};
    color: ${p => p.theme.flyout.headerFg};

    cursor: pointer;
`;

export const HeaderImg = styled(Img)`
    width: 48px;
    height: 48px;
    border-radius: 100px;

    color: ${p => p.theme.flyout.headerImgColor};
    object-fit: cover;

    /* display: flex;
    justify-content: center;
    align-items: center; */
`;

export const HeaderName = styled.div`
    ${p => p.theme.fontStyles.AccentHeader3Fixed}

    margin-top: 20px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const HeaderEmail = styled.div`
    ${p => p.theme.fontStyles.Body5Fixed}

    opacity: 0.7;

    margin-top: 4px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const MenuArea = styled.div`
    padding: 20px 12px;

    display: flex;
    flex-direction: column;

    flex-grow: 1;
    flex-shrink: 0;
`;

export const MenuItemWrapper = styled.div.attrs({ role: "button", tabIndex: 0 })`
    height: 40px;
    padding: 0 12px;

    margin-bottom: 8px;

    ${p => p.theme.fontStyles.Header4Fixed}
    display: flex;
    align-items: center;

    & > :first-child {
        margin-right: 20px;
    }

    cursor: pointer;
`;

export const Footer = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 16px;

    && {
        color: ${p => p.theme.fgColorDark};
    }
`;
